export const kodeAkunFormData = (dropdownSubChildCategory) => {
  return [
    {
      id: "kode_akun",
      label: "Kode Akun",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Kode Akun",
        },
      ],
    },
    {
      id: "nama_akun",
      label: "Nama Akun",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nama Akun",
        },
      ],
    },
    {
      id: "ref",
      label: "Pilih Ref",
      fields: [
        {
          type: "option",
          options: [
            // {
            //     label: "Pilih Ref...",
            //     value: "",
            // },
            {
              label: "laba rugi",
              value: "laba rugi",
            },
            {
              label: "neraca",
              value: "neraca",
            },
          ],
        },
      ],
    },
    {
      id: "n_akun",
      label: "Pilih N Akun",
      fields: [
        {
          type: "option",
          options: [
            // {
            //     label   : "Pilih N Akun...",
            //     value   : "",
            // },
            {
              label: "debet",
              value: "debet",
            },
            {
              label: "kredit",
              value: "kredit",
            },
          ],
        },
      ],
    },
    {
      id: "id_akun_sub_child_kategori",
      label: "Pilih Sub Child Kategori",
      fields: [
        {
          type: "option",
          options: dropdownSubChildCategory,
        },
      ],
    },
    {
      id: "saldo_akun_awal",
      label: "Saldo Awal",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Saldo Awal (Optional)",
        },
      ],
    },
  ];
};
